// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperationCondition } from './operationCondition';
import { DeterminationType } from './determinationType';
import { WaterIntakeEntryCommentView } from './waterIntakeEntryCommentView';
import { BelowLdLq } from './belowLdLq';
import { DataType } from './dataType';
import { MonitoringType } from './monitoringType';
import { EntryStatus } from './entryStatus';


export interface WaterIntakeEntriesView { 
    /**
     * The Water Intake Entry primary key
     */
    id: number;
    /**
     * The parameter id
     */
    idParameter: number;
    /**
     * The shop id
     */
    idShop: number;
    /**
     * The tool id
     */
    idTool: number;
    /**
     * The emission point id
     */
    idEmissionPoint: number;
    /**
     * The site id
     */
    idSite: number;
    /**
     * The period id
     */
    idPeriod: number;
    /**
     * The entry cycle id
     */
    idEntryCycle: number;
    /**
     * The value of the waterIntake entry measurement
     */
    value: number;
    /**
     * The unit of the waterIntake entry measurement
     */
    unit: string;
    belowLdLq: WaterIntakeEntriesView.BelowLdLqEnum | null;
    operationCondition: OperationCondition;
    dataType: DataType;
    determinationType: DeterminationType;
    monitoringType: MonitoringType;
    status: EntryStatus;
    /**
     * The user id who updated the waterIntake entry
     */
    updatedBy: number;
    /**
     * The user id who reviewed the waterIntake entry
     */
    approvedBy: number;
    /**
     * The date and time the waterIntake entry was reviewed
     */
    approvedAt: string;
    /**
     * List of comments related to the waterIntake entry
     */
    comments: Array<WaterIntakeEntryCommentView>;
}
export namespace WaterIntakeEntriesView {
    export type BelowLdLqEnum = 'LD' | 'LQ';
    export const BelowLdLqEnum = {
        LD: 'LD' as BelowLdLqEnum,
        LQ: 'LQ' as BelowLdLqEnum
    };
}


